import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { EditableGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/editable-grid/editable-grid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { DetailLedgerKind, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { GridFilter, PagingDataResult, isNumber } from "projects/sepidz-web-framework/src/lib/services";
import { BehaviorSubject, Observable } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TrsVoucherKind } from "../../models/trs-voucher-kind.model";

@Component({
  selector: "ngx-trs-voucher-kind-form",
  templateUrl: "./trs-voucher-kind-form.component.html",
  styleUrls: ["./trs-voucher-kind-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrsVoucherKindFormComponent extends BaseFormComponent<TrsVoucherKind> {
  activeTabTitle: string;
  DefaultValues: Dictionary = [];
  invColumns: form_control[];
  sellColumns: form_control[];
  detailsColumns: form_control[];
  TrsVoucherKindConcerns: form_control[];
  TrsReferenceVoucherKinds: form_control[];
  TrsVoucherKindDetailLedgerKinds: form_control[];
  TrsVoucherKindTreasuryDetailLedgerKinds: form_control[];
  public FormControlTypes = FormControlTypes;
  @ViewChild("Concern") public Concern: EditableGridComponent;
  @ViewChild("ReferenceVoucherKind") public ReferenceVoucherKind: EditableGridComponent;
  @ViewChild("VoucherKindDetailLedgerKind") public VoucherKindDetailLedgerKind: EditableGridComponent;
  @ViewChild("VoucherKindTreasuryDetailLedgerKind") public VoucherKindTreasuryDetailLedgerKind: EditableGridComponent;
  constructor(
    private datatransfer: Datatransfer,
    __id: FormContainerModel,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    _tabsservice: TabularService
  ) {
    super(selectorService, cd);
    this.currentrow = this.datatransfer?.currentrow;
    this.apiName = this.datatransfer?.apiName;
    this.label = this.datatransfer?.label;
    this.areaName = this.datatransfer?.areaName;
    this._id = __id;
    this.tabsservice = _tabsservice;
    this.onDataStateChange = this.onDataStateChange.bind(this);
  }
  async ngOnInit() {
    this.apiName = "TrsVoucherKind";
    this.label = "انواع سند";
    super.ngOnInit();
    this.canDeactivate = this.canDeactivate.bind(this);
  }
  setdefault() {
    this.selectorService.setDataStateChange("DetailLedgerKindId", this.onDataStateChange);
    if (this.model && this.model.Title) {
      this.label = this.model.Title + `(${this.model.Code ?? 0})`;
      this.tabsservice.setTabTitle(this._id.metadata.id, this.getFormTitle());
    }

    this.DefaultValues["TrsVoucherKindId"] = 0;
    this.DefaultValues["TrsVoucherKindId"] = 0;
    if (this.model.Active === undefined) this.model.Active = true;

    if (!this.model.OrderByNumber) this.model.OrderByNumber = 1;
    if (!this.model.TrsReferenceVoucherKinds) this.model.TrsReferenceVoucherKinds = [];
    if (!this.model.TrsVoucherKindDetailLedgerKinds) this.model.TrsVoucherKindDetailLedgerKinds = [];
    if (!this.model.TrsVoucherKindTreasuryDetailLedgerKinds) this.model.TrsVoucherKindTreasuryDetailLedgerKinds = [];
    if (!this.model.TrsVoucherKindConcerns) this.model.TrsVoucherKindConcerns = [];
    this.setDefaultValues();
  }
  addControl() {
    this.cd.markForCheck();
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.DefaultValues = undefined;
    this.invColumns = undefined;
    this.sellColumns = undefined;
    this.detailsColumns = undefined;
    this.TrsVoucherKindConcerns = undefined;
    this.TrsReferenceVoucherKinds = undefined;
    this.TrsVoucherKindDetailLedgerKinds = undefined;
    this.TrsVoucherKindTreasuryDetailLedgerKinds = undefined;
    this.FormControlTypes = undefined;
    this.Concern = undefined;
    this.ReferenceVoucherKind = undefined;
    this.VoucherKindDetailLedgerKind = undefined;
    this.VoucherKindTreasuryDetailLedgerKind = undefined;
  }
  setMaxCode() {
    this.httpCommonService
      .getMaxCode(this.apiName)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (!this.model) this.model = <TrsVoucherKind>{};
        if (data) {
          this.model["Code"] = data as number;
        }
        this.setdefault();
        this.setFormGroup(this.model);
      });
  }
  setDefaultValues() {
    this.orignalColumns.forEach((x) => {
      if (x.controlType === FormControlTypes.checkbox && this.model[x.name] === undefined) this.model[x.name] = false;
    });
  }

  async setColumns() {
    this.httpCommonService
      .getControlsList(this.apiName.split("/")[0])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (data) {
          this.orignalColumns = data as form_control[];
          this.columns = (data as form_control[]).filter(
            (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
          );
          this.columns = this.columns.sort((a, b) => a.order - b.order);
          this.setColumnNumber(this.columns, 6);
          this.detailsColumns = (data as form_control[]).filter(
            (f) => ((!f.areaName || f.areaName === "details") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
          );
          this.detailsColumns = this.detailsColumns.sort((a, b) => a.order - b.order);
          this.setColumnNumber(this.detailsColumns, 6);
          this.TrsVoucherKindConcerns = this.getDetailControlModels("TrsVoucherKindConcerns");
          this.TrsReferenceVoucherKinds = this.getDetailControlModels("TrsReferenceVoucherKinds");
          this.TrsVoucherKindDetailLedgerKinds = this.getDetailControlModels("TrsVoucherKindDetailLedgerKinds");
          this.TrsVoucherKindTreasuryDetailLedgerKinds = this.getDetailControlModels("TrsVoucherKindTreasuryDetailLedgerKinds");
          this.setdefault();
          this.setFormGroup(this.model);
        }
      });
    this.columns.forEach((x) => (x.isFloat = null));
    this.cd.markForCheck();
  }

  beforupdate() {
    if (this.Concern) this.Concern.saveCurrent();
    if (this.ReferenceVoucherKind) this.ReferenceVoucherKind.saveCurrent();
    if (this.VoucherKindDetailLedgerKind) this.VoucherKindDetailLedgerKind.saveCurrent();
    if (this.VoucherKindTreasuryDetailLedgerKind) this.VoucherKindTreasuryDetailLedgerKind.saveCurrent();

    if (this.model.TrsReferenceVoucherKinds && this.model.TrsReferenceVoucherKinds.length <= 0) this.model.TrsReferenceVoucherKinds = null;
    else this.setValue("TrsReferenceVoucherKinds", this.model.TrsReferenceVoucherKinds);

    if (this.model.TrsVoucherKindConcerns && this.model.TrsVoucherKindConcerns.length <= 0) this.model.TrsVoucherKindConcerns = null;
    else this.setValue("TrsVoucherKindConcerns", this.model.TrsVoucherKindConcerns);
    if (this.model.TrsVoucherKindDetailLedgerKinds && this.model.TrsVoucherKindDetailLedgerKinds.length <= 0)
      this.model.TrsVoucherKindDetailLedgerKinds = null;
    else this.setValue("TrsVoucherKindDetailLedgerKinds", this.model.TrsVoucherKindDetailLedgerKinds);
    if (this.model.TrsVoucherKindTreasuryDetailLedgerKinds && this.model.TrsVoucherKindTreasuryDetailLedgerKinds.length <= 0)
      this.model.TrsVoucherKindTreasuryDetailLedgerKinds = null;
    else this.setValue("TrsVoucherKindTreasuryDetailLedgerKinds", this.model.TrsVoucherKindTreasuryDetailLedgerKinds);
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.saveDetailInfo();
    this.activeTabTitle = $event.tabTitle;
  }
  saveDetailInfo() {
    if (this.Concern) this.Concern.saveCurrent();
    if (this.ReferenceVoucherKind) this.ReferenceVoucherKind.saveCurrent();
    if (this.VoucherKindDetailLedgerKind) this.VoucherKindDetailLedgerKind.saveCurrent();
    if (this.VoucherKindTreasuryDetailLedgerKind) this.VoucherKindTreasuryDetailLedgerKind.saveCurrent();
  }
  getDetailControlModels(keyName: string) {
    let columns = this.orignalColumns.find((x) => x.name === keyName).DetailControlModels[keyName];
    for (var i = 0; i < columns.length; i++) {
      if (columns[i]["apiName"]) columns[i]["isMulti"] = true;
    }
    return columns;
  }
  close() {
    this.accountService.authService.getMvcController();
    super.close();
  }

  getFilters(columnsName: string, searchValue: string, skip: number, take: number) {
    var filters: GridFilter[] = [];
    const columns = columnsName.split(",");
    columns.forEach((x) => {
      {
        if (x !== "Id")
          filters.push({ Filed: x, Operator: "contains", Type: "F", Skip: skip, Take: take, Value: searchValue.toString(), Logic: "or" });
        else if (isNumber(searchValue))
          filters.push({ Filed: x, Operator: "eq", Type: "F", Skip: skip, Take: take, Value: Number(searchValue), Logic: "or" });
      }
    });
    return filters;
  }
  onDataStateChange(columnName: string, searchValue: string, skip: number, take: number): Observable<PagingDataResult<DetailLedgerKind>> {
    var abs = new BehaviorSubject<PagingDataResult<DetailLedgerKind>>(undefined);
    const DetailLedgerKindIds: number[] = [];
    let apiName: string = "DetailLedgerKind/GetDetailLedgerKindById";
    if (columnName === "DetailLedgerKindId" && this.VoucherKindDetailLedgerKind?.formGroup) {
      this.model.TrsVoucherKindDetailLedgerKinds.forEach((x) => {
        if (x.State !== RowState.Delete && x.State !== RowState.Detached) DetailLedgerKindIds.push(x.DetailLedgerKindId);
      });
    }
    if (columnName === "DetailLedgerKindId" && this.VoucherKindTreasuryDetailLedgerKind?.formGroup) {
      this.model.TrsVoucherKindTreasuryDetailLedgerKinds.forEach((x) => {
        if (x.State !== RowState.Delete && x.State !== RowState.Detached) DetailLedgerKindIds.push(x.DetailLedgerKindId);
      });
    }
    const filter = this.getFilters("Id,Code,Title", searchValue, skip, take);
    if (DetailLedgerKindIds && DetailLedgerKindIds.length > 0)
      filter.push({ Filed: "DetailLedgerKindIds", Operator: "eq", Value: DetailLedgerKindIds, Type: "F", Skip: skip, Take: take, Logic: "and" });
    this.httpCommonService
      .GetFilterGrid<PagingDataResult<DetailLedgerKind>>(apiName, filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x: PagingDataResult<DetailLedgerKind>) => {
        if (x) abs.next(x);
      });
    return abs.asObservable();
  }
}
